<div class="row mt-5">
  <div class="col-12">
    <div
      class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mt-3 mb-2">
      <h3 class="fw-bold fs-6 mb-0">Meta Ads Status</h3>
      <i class="bi bi-upload text-primary me-2"></i>
    </div>
    <div class="text-end">
      <button type="button" (click)="refreshAccountInfos()"
              class="btn btn-primary btn-sm fw-bold">
        Refresh
      </button>
    </div>
    <div class="mb-3">
      <span class="fw-bold">Timezone: </span><span>{{ getMetaAdsTimezoneOffset() }}</span>
    </div>
  </div>
</div>
